import * as React             from 'react';
import * as storage from '../../util/storage';
import { Redirect }           from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actionCreators    from '../../action-creators';
import * as routes            from '../../util/routes';
import Auth                   from '../../service/auth';
import TokenService           from '../../service/sfp/token-service';
import LoginComponent         from './login-component';
import UsersService from '../../service/sfp/users-service';


import {KEY_CURRENT_LOCAL_AUTHORITY} from "../../util/storage"
import LocalAuthoritiesService from '../../service/sfp/local-authorities-service';

class LoginContainer extends React.Component {
	constructor(props) {
		super(props);

		document.title = 'Connexion | SFP Collectivités';

		this.state = { submitting: false,
					   isError: false };
	}

	render() {
		return <LoginComponent submitting={this.state.submitting} isError={this.state.isError} onSubmit={this._handleFormSubmit}/>
	}

	_handleFormSubmit = (e) => {
		e.preventDefault();
		this.setState({ submitting: true });

		const username = e.target.username.value;
		const password = e.target.password.value;

		TokenService.findToken(username, password)
			.then(this._resolveFindToken, this._rejectFindToken);

		this.setState({ submitting: false });
	}

	_rejectFindToken = (error) => {
		this.setState({ submitting: false, isError: true });
	}

	_resolveFindToken = async (response) => {
		Auth.signIn(response);
		this.props.actions.throwError(null);
		// this.props.history.replace(this.props.location);
		await UsersService.findCurrentUser().then(async (currentUser) => {
			if (currentUser && currentUser.managedLocalAuthority) {
				await LocalAuthoritiesService.findLocalAuthorityByIdOrSlug(currentUser.managedLocalAuthority).then(async (localAuthority) => {
					if (localAuthority && localAuthority.slug) {
						this.props.history.push('/' + localAuthority.slug);
					} else {
						this.props.history.push(routes.ROOT);
					}
				}).catch((error) => {
					this.props.history.push(routes.ROOT);
				});
			} else {
				this.props.history.push(routes.ROOT);
			}
		}).catch((error) => {
			this.props.history.push(routes.ROOT);
		});
	}
}

const mapStateToProps = state => state;
const mapDispatchToProps = (dispatch) => (
	{actions: bindActionCreators(actionCreators, dispatch)}
);

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);



// WEBPACK FOOTER //
// ./src/route/login/login-container.js